// fetchDiamondPacks.js
// TODO: rename fetchDiamondPacks to fetchProductSkus
'use strict';
import 'isomorphic-fetch';
import parseLinkHeader from 'parse-link-header';
import getResourceUrl from '../resource/getResourceUrl.js';

import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';
import objectifyArrayById from '../resource/objectifyArrayById.js';
import { SHOP_ID, ProductType } from '../resource/shopConstants.js';
import getMeData from '../selector/getMeData.js';
import {
  ADD_LIST_ITEMS,
  SET_LIST_ITEMS,
  ADD_DIAMOND_PACKS,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Fetch diamond packs
 * @kind action
 * @param {string} [{currency}] - specify price currency.
 * @param {number} [{page}] - specify the page.
 * @param {string} [{shopId = 'addvalue'}] - specify shop id.
 * @param {string} [{type = 'diamonds'}] - product type.
 * @param {array} [{productIds = []}] - specify product ids.
 * @param {object} {[httpProxyHeaders = {}]} - http proxy headers for SSR.
 * @return {Promise} Action promise.
 */
const fetchDiamondPacks =
  ({
    currency,
    page = 1,
    shopId = SHOP_ID.addvalue,
    type = ProductType.DIAMONDS,
    productIds = [],
    httpProxyHeaders = {},
  } = {}) =>
  async (dispatch, getState) => {
    const selectPath = [
      ProductType.SUBSCRIPTIONS,
      ProductType.MESSAGEPACKS,
    ].includes(type)
      ? ['shop', shopId, currency, type, productIds[0]]
      : ['shop', shopId, currency, 'diamondPacks'];
    const token = getMeData(getState(), 'token');

    const url = getResourceUrl({ endpoint: '/shop/products' });

    if (type) {
      url.searchParams.append('type', type);
    }

    url.searchParams.append('page', page);

    if (currency) {
      url.searchParams.append('currency', currency);
    }
    if (productIds.length) {
      productIds.forEach(productId => url.searchParams.append('id', productId));
    }

    const fetchOptions = {
      headers: {
        ...getHeaders(),
        ...httpProxyHeaders,
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    };

    dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });

    try {
      let response = await fetch(url.href, fetchOptions);

      if (!response.ok) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl: url,
        });
      }

      const payload = await response.json();

      const diamondPacks = objectifyArrayById({ array: payload });
      const itemIds = Object.keys(diamondPacks);
      dispatch({ type: ADD_DIAMOND_PACKS, payload: { diamondPacks } });

      const totalCount = parseInt(response.headers.get('x-total-count'), 10);
      const links = parseLinkHeader(response.headers.get('link'));
      const nextPage = links && links.next && parseInt(links.next.page, 10);
      const lastPage = links && links.last && parseInt(links.last.page, 10);
      const isFirstPage = page === 1;
      dispatch({
        type: isFirstPage ? SET_LIST_ITEMS : ADD_LIST_ITEMS,
        payload: { selectPath, itemIds, totalCount, nextPage, lastPage },
      });

      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath, error },
      });
    }
  };

export default fetchDiamondPacks;
